import { render } from "./Domain.vue?vue&type=template&id=57572d7e&scoped=true"
import script from "./Domain.vue?vue&type=script&lang=js"
export * from "./Domain.vue?vue&type=script&lang=js"

import "./Domain.vue?vue&type=style&index=0&id=57572d7e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57572d7e"]])

export default __exports__